import axios, { AxiosInstance } from 'axios';
import { auth } from '../firebase';

const CLIENT_TOKEN = import.meta.env.VITE_API_CLIENT_TOKEN;
if (!CLIENT_TOKEN) {
    console.warn(
        '[Admin] VITE_API_CLIENT_TOKEN nav iestatīts .env.local - X-Client-Token nepiesien, sagaidām 403.',
    );
}

/**
 * Axios klients, kas katrai uz `/api/v1/admin/*` adresētai prasībai pievieno:
 *  - `X-Client-Token` (validē ClientHeaderAuthorizationFilter serverī)
 *  - `Authorization: Bearer <Firebase ID token>` (validē FirebaseAuthenticationHandler)
 *
 * Firebase ID token tiek pieprasīts no `auth.currentUser` katru reizi - SDK iekšēji
 * cachē un automātiski atjauno, ja tas ir tuvu beigām.
 */
function createApiClient(): AxiosInstance {
    const client = axios.create({
        baseURL: import.meta.env.VITE_API_BASE_URL || '',
        headers: { 'Content-Type': 'application/json' },
    });

    client.interceptors.request.use(async (config) => {
        if (CLIENT_TOKEN) {
            config.headers['X-Client-Token'] = CLIENT_TOKEN;
        }
        const user = auth.currentUser;
        if (user) {
            const token = await user.getIdToken();
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    });

    client.interceptors.response.use(
        (r) => r,
        (error) => {
            // 401/403 - vai nu nav admin claim, vai tokens vairs neder. Centralizēta logošana.
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                console.warn('Admin API auth neizdevās:', error.response.status, error.response.data);
            }
            return Promise.reject(error);
        },
    );
    return client;
}

export const api = createApiClient();
